<template>
  <estimate-constructor
    v-if="$store.state.prices.curPrice"
    :curPrice="$store.state.prices.curPrice"
    storeSaveFunc="estimates/create"
    :ownerId="$store.state.users.localUser._id"
  ></estimate-constructor>
  <v-container v-else>
    <v-container class="ma-0 pa-0 pb-5 d-flex" style="align-items: center;">
      <h1>Конструктор сметы</h1>
    </v-container>
    <v-progress-linear indeterminate v-if="loadingList">
    </v-progress-linear>
    <v-alert v-else class="mt-3" type="warning" outlined dense>
      Для использования конструктора создайте прайс-лист.
    </v-alert>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import EstimateConstructor from '../components/constructor/EstimateConstructor';

export default {
  components: {
    EstimateConstructor
  },

  created() {
    this.$store.dispatch('prices/loadList');
  },

  computed: {
    ...mapGetters('prices', ['loadingList'])
  }
}
</script>